<ion-grid class="quiniela-grid">
  <ion-row class="table-header">
    <ion-col size="4" class="center">{{ protouchS ? 'Gana x dif de más de 6 pts (L)' : 'Local' }}</ion-col>
    <ion-col size="4" class="center">{{ protouchS ? 'Dif max de 6 pts (D)' : 'Empate' }}</ion-col>
    <ion-col size="4" class="center">{{ protouchS ? 'Gana x dif de más de 6 pts (V)' : 'Visita' }}</ion-col>
  </ion-row>

  <ion-row *ngFor="let match of matches" class="match-row">
    <ion-col size="4" class="center">
      <div class="team">
        <ion-icon
          name="shirt"
          [class.blue]="isSelected(match, 'local')"
          (click)="toggleSelection(match, 'local')"
        ></ion-icon>
        <span class="team-name" [class.selected]="isSelected(match, 'local')" (click)="toggleSelection(match, 'local')">
          {{ match.local }}
        </span>
      </div>
    </ion-col>

    <ion-col size="4" class="center">
      <ion-icon
        name="shirt"
        [class.orange]="isSelected(match, 'draw')"
        (click)="toggleSelection(match, 'draw')"
      ></ion-icon>
    </ion-col>

    <ion-col size="4" class="center">
      <div class="team visit-team">
        <span class="team-name" [class.selected]="isSelected(match, 'visit')" (click)="toggleSelection(match, 'visit')">
          {{ match.visit }}
        </span>
        <ion-icon
          name="shirt"
          [class.red]="isSelected(match, 'visit')"
          (click)="toggleSelection(match, 'visit')"
        ></ion-icon>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
